export default {
  tone: {
    value: [
      'Formal',
      'Informal',
      'Humorous',
      'Assertive',
      'Sarcastic',
      'Optimistic'
    ],
    description: 'v5:story_description_tone'
  },
  narrativeHook: {
    isOptional: true,
    value: '',
    description: 'v5:story_description_narrative_hook'
  },
  narrativeStyle: {
    value: [
      'First person',
      'Second person',
      'Third person limited',
      'Third person omniscient',
      'Epistolary'
    ],
    description: 'v5:story_description_narrative_style'
  },
  storyPlot: {
    isOptional: true,
    value: '',
    description: 'v5:story_description_story_plot'
  },
  complexity: {
    value: ['Beginner', 'Intermediate', 'Advanced', 'Experimental'],
    description: 'v5:story_description_complexity'
  },
  genre: {
    value: [
      'Realistic',
      'Historical',
      'Casual',
      'Drama',
      'Fantasy',
      'Adventure',
      'Satire',
      'Science fiction',
      'Mystery'
    ],
    description: 'v5:story_description_genre'
  },
  vocabulary: {
    value: [
      'Simple',
      'Moderate',
      'Advanced',
      'Jargon or technical',
      'Period-specific',
      'Slang or colloquial'
    ],
    description: 'v5:story_description_vocabulary'
  },
  narrativeStructure: {
    value: [
      'Linear',
      'Non-linear',
      'Circular',
      'In media res',
      'Framed narrative'
    ],
    description: 'v5:story_description_narrative_structure'
  },
  timePeriod: {
    value: ['Past', 'Present', 'Future', 'Timeless or unspecified'],
    description: 'v5:story_description_time_period'
  },
  storyLength: {
    value: [
      'Short (300 - 500 words)',
      'Medium (500 - 800 words)',
      'Long (800+ words)'
    ],
    description: 'v5:story_description_story_length'
  },
  characterNames: {
    value: [],
    description: 'v5:story_description_character_names'
  },
  outputType: {
    value: ['Screenplay', 'Narrative'],
    description: 'v5:story_description_output_type'
  }
}
